import { faEdit, faLock, faLockOpen, faPlusSquare, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import AppContext from '../../../contexts/AppContext';

function Threat({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const {user, openModal} = useContext(AppContext);
  const keys = Object.keys(data.handles);

  useEffect(()=>{
    setLockedByUsername(data.lockedByUsername)
  },[data.lockedByUsername])

  useEffect(()=>{
    setText(data.text)
  },[data.text])

  return (
    <>
      <div className="custom-node__header bg-teal-700 flex justify-between rounded-t-[15px]">
        <strong className='text-slate-200'>Cause</strong>
        <div className="flex gap-0.5">
        <div className={`${lockedByUsername ? 'text-slate-700 bg-slate-100 rounded-lg' : 'text-slate-300'} px-2 flex justify-between items-center`}>
            {lockedByUsername?
              <div><span className='text-[12px] px-1 rounded'><FontAwesomeIcon icon={faLock}/> <span className='ml-1'>{lockedByUsername == user?.sub? 'You': data.lockedByUsername}</span></span> </div>
              : <><div data-tooltip-content={'Edit/Lock'} data-tooltip-id='edit' onClick={async()=>{
                const status = await data.acquireLock();
                if(status==200){
                setLockedByUsername(user.sub)
                }
              }} className='text-slate-100  ml-2 px-[4px] rounded cursor-pointer'>
                <FontAwesomeIcon icon={faEdit} size='sm' />
              </div>
              <Tooltip place='top' id='edit' /></> }

              {(lockedByUsername === user?.sub) && 
              <>
              <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-teal-600 text-[12px] bg-white ml-2 px-[4px] rounded cursor-pointer'>
                <FontAwesomeIcon icon={faSave} />
              </div>
              <Tooltip place='top' id='save' />
              </>
              }
          </div>
          <div data-tooltip-content={'Delete Cause of CE'} data-tooltip-id='delete-CE' onClick={() =>{ 
            openModal("Delete Cause of CE??", 
            `Are you sure you want to delete Cause of CE "${id}"`,
            ()=>{data.delete(id)}
            )
            }}  className='text-red-600  px-[4px] rounded cursor-pointer'>
            <FontAwesomeIcon icon={faTrash} size='sm' />
          </div>
          <Tooltip place='top' id='delete-CE' />
         
        </div>
      </div>
      
      <div className="custom-node__body flex rounded-b-xl">
      <textarea
        value={text}
        disabled={(lockedByUsername!==user?.sub)}
        onChange={(e)=>{data.text = e.currentTarget.value; setText(data.text);}}
        placeholder={'Threat description'}
        rows={"4"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
        leading-tight focus:outline-none focus:shadow-outline" 
      />
      <div data-tooltip-content={'Add Preventive Barrier'} data-tooltip-id='apb' onClick={()=>data.addBarrier(id)} className='h-4 w-4 flex justify-center items-center fixed left-[-8px] top-[44%] z-50 bg-white rounded cursor-pointer'>
        <FontAwesomeIcon icon={faPlusSquare} size='1x' color='black' />
      </div>
      <Tooltip place='bottom' id='apb' />
      </div>
      {/* Outgoing connections */}
        <Handle type="source" position={Position.Right} id={keys[0]} />

        {/* Incoming connections */}
        <Handle type="target" position={Position.Left} id="handle-left" />

    </>
  );
}

export default memo(Threat);
